



































import { approvalRejectApi } from "@/api/approve";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() approvalId!: number;
  form: any = {};
  dialogVisible: boolean = false;
  rules = {
    remark: [{ required: true, message: "请填写拒绝原因", trigger: "change" }],
  };
  openDialog() {
    this.dialogVisible = true;
  }
  handleClose() {
    this.form.remark = "";
    this.dialogVisible = false;
  }
  handleSubmit() {
    (this.$refs["mainForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          approvalRejectApi({
            approval_id: this.approvalId,
            remark: this.form.remark,
          }).then(() => {
            this.$message({
              type: "success",
              message: "拒绝成功!",
            });
            this.$emit("change");
            this.handleClose();
          });
        }
      }
    );
  }
}
